export default __webpack_public_path__ + "static/media/etherscan-logo.39101675.jpg";